import client from './apiClient';
const cache = {};
const errorCache = {};

function getData(appId, url) {
  if (errorCache[url] !== undefined) return Promise.reject(errorCache[url]);
  if (cache[url] !== undefined) return Promise.resolve(cache[url]);

  return client(
    `gridTranslate?RowLimit=0&appId=${encodeURIComponent(
      appId
    )}&url=${encodeURIComponent(url)}`
  ).then(
    (gridData) => {
      cache[url] = gridData;
      return gridData;
    },
    (error) => {
      errorCache[url] = error;
      return Promise.reject(error);
    }
  );
}
export { getData };
